import { MotoSettleConfig } from "@motosettle/sdk";
import { Address } from "viem";

export const getNetwork = () => localStorage.getItem("MOTOSETTLE_NETWORK") || "TESTNET";

export const setNetwork = (network: "MAINNET" | "TESTNET") => {
  localStorage.setItem("MOTOSETTLE_NETWORK", network);
  window.location.reload();
};

export const getConfig = (): MotoSettleConfig => {
  const isMainnet = getNetwork() === "MAINNET";

  if (isMainnet) {
    return {
      escrowCore:         (import.meta.env.VITE_MAINNET_ESCROW_CORE    || "0x0000000000000000000000000000000000000001") as Address,
      router:             (import.meta.env.VITE_MAINNET_ROUTER          || "0x0000000000000000000000000000000000000002") as Address,
      arbitratorRegistry: (import.meta.env.VITE_MAINNET_ARB_REGISTRY   || "0x0000000000000000000000000000000000000003") as Address,
      userReputation:     (import.meta.env.VITE_MAINNET_USER_REPUTATION || "0x0000000000000000000000000000000000000004") as Address,
      feePolicy:          (import.meta.env.VITE_MAINNET_FEE_POLICY      || "0x0000000000000000000000000000000000000005") as Address,
      indexerUrl:         import.meta.env.VITE_MAINNET_INDEXER_URL || "https://api.thegraph.com/subgraphs/name/motosettle/mainnet",
    };
  } else {
     return {
      escrowCore:         (import.meta.env.VITE_TESTNET_ESCROW_CORE    || "opt1sqrzflyulxkfzw0mlxsdrj5t86hs28rhu4spncxy3") as Address,
      router:             (import.meta.env.VITE_TESTNET_ROUTER          || "opt1sqzggy0gvsjquycnnhqyv8n2n3j6km42uxuxkttyz") as Address,
      arbitratorRegistry: (import.meta.env.VITE_TESTNET_ARB_REGISTRY   || "opt1sqqv5r0ks26yvwtpfwt5jsee8jedxyuzqyyu2ljqk") as Address,
      userReputation:     (import.meta.env.VITE_TESTNET_USER_REPUTATION || "opt1sqpulme8jnzv87v9s7e22yyslkz90cgsz6yv5erev") as Address,
      feePolicy:          (import.meta.env.VITE_TESTNET_FEE_POLICY      || "opt1sqzu0tkk4w52n6kr2yjuyk4g8zkl6llp3gsznvsqg") as Address,
      indexerUrl:         import.meta.env.VITE_TESTNET_INDEXER_URL || "https://api.thegraph.com/subgraphs/name/motosettle/testnet",
    };
  }
};

export const MOTOSETTLE_CONFIG: MotoSettleConfig = getConfig();

console.log("[MotoSettle Config] network:", getNetwork());
console.log("[MotoSettle Config] escrowCore:", MOTOSETTLE_CONFIG.escrowCore);
console.log("[MotoSettle Config] router:", MOTOSETTLE_CONFIG.router);
console.log("[MotoSettle Config] feePolicy:", MOTOSETTLE_CONFIG.feePolicy);
console.log("[MotoSettle Config] envCheck:", import.meta.env.VITE_TESTNET_ROUTER ?? "ENV NOT LOADED");

// Expose config globally for debugging
(window as any).__MOTOSETTLE_CONFIG__ = MOTOSETTLE_CONFIG;

export const SUPPORTED_TOKENS = [
  { symbol: "USDC", address: "0x..." as Address, decimals: 6 },
  { symbol: "WBTC", address: "0x..." as Address, decimals: 8 },
  { symbol: "MOTO", address: "0x..." as Address, decimals: 18 },
];
